import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
    computed: {
        ...mapGetters('discount', ['discountList']),

        discountLoading() {
            return this.onLoading('fetch-discount');
        },
    },

    methods: {
        ...mapActions('discount', [
            'getDiscount',
            'getDiscountListIfNecessary',
        ]),

        describeDiscount(discount) {
            let desc = '';
            let adj = 'on';

            if (discount.mode === 3) {
                desc = `Discount ${discount.amount}% `;
            } else if (discount.mode === 2) {
                desc = `Deduct ${discount.amount} `;
                adj = 'from';
            }

            if (discount.tags !== undefined) {
                if (discount.tags.length === 1) {
                    desc += `${adj} ${discount.tags[0].name} tag`;
                } else if (discount.tags.length > 1) {
                    desc += `${adj} ${discount.tags.length} tags`;
                }
            }

            return desc;
        },

        refreshDiscountList: _.debounce(function(query) {
            this.getDiscountListIfNecessary({ query: query });
        }, 500),
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/discounts.js